import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let EventOption: LazyOption = createLazyOption(
    {
        key: 'event',
        titleStringKey: 'optionTitle_event',
        searchTermsStringKey: 'optionSearch_event',
        isHidden: () => !isFeatureEnabled('cal-event-invitation-setting'),
    },
    lazyFullModule,
    m => m.default
);
export default EventOption;
